import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function BikeCard({ bike, large = false, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.55, delay: index * 0.05, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative bg-[#141414] border border-white/10 hover:border-[#E50000]/60 hover:-translate-y-1 transition-all duration-300 hover:shadow-[0_8px_32px_rgba(229,0,0,0.18)] ${
        large ? "md:col-span-2 md:row-span-2" : ""
      }`}
      data-testid={`bike-card-${bike.id}`}
    >
      <Link to={`/catalog/${bike.id}`} className="block h-full">
        <div className={`relative overflow-hidden ${large ? "aspect-[16/11]" : "aspect-[4/3]"} bg-[#0A0A0A]`}>
          <img
            src={bike.image_url}
            alt={`${bike.brand} ${bike.model}`}
            loading="lazy"
            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/0 to-black/0" />
          <div className="absolute top-4 left-4 flex gap-2">
            <span className="text-[10px] font-bold uppercase tracking-[0.18em] bg-[#E50000] text-white px-2 py-1">
              {bike.condition === "New" ? "Καινούργιο" : "Μεταχ."}
            </span>
            <span className="text-[10px] font-bold uppercase tracking-[0.18em] bg-black/60 backdrop-blur text-white px-2 py-1 border border-white/10">
              {bike.category}
            </span>
          </div>
          <div className="absolute top-4 right-4 w-9 h-9 bg-black/60 border border-white/10 flex items-center justify-center group-hover:bg-[#E50000] group-hover:border-[#E50000] transition-colors">
            <ArrowUpRight size={16} weight="bold" />
          </div>
        </div>

        <div className="p-6 md:p-7 flex flex-col gap-3">
          <p className="text-overline">{bike.brand} · {bike.year}</p>
          <h3 className={`font-display font-black uppercase tracking-tight text-white ${large ? "text-3xl md:text-4xl" : "text-xl md:text-2xl"}`}>
            {bike.model}
          </h3>
          <div className="flex items-end justify-between pt-3 border-t border-white/10 mt-2">
            <div>
              <p className="text-[10px] uppercase tracking-widest text-white/40 font-mono">{bike.coming_soon ? "Σύντομα διαθέσιμη" : "Από"}</p>
              <p className="font-display font-bold text-2xl text-white">
                {bike.coming_soon ? "— — —" : `€${bike.price.toLocaleString()}`}
              </p>
            </div>
            <div className="text-right text-xs font-mono text-white/50">
              <span className="block">{bike.engine_cc}cc · {bike.power_hp}hp</span>
              <span className="block">{bike.mileage_km.toLocaleString()} χλμ</span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
